import React from 'react'
import { withDrawer } from '../../common/Drawer/Drawer'
import cx from '../../../utils/className'

import styles from './ProductDescription.module.css'

const DescriptionContent = ({ descList = [] }) => {
  return (
    <div className={styles.descContent}>
      {
        descList.map(desc => (
          <div className={styles.descContentWrapper} key={desc.materialName}>
          <div className={styles.descName}>{desc.materialName}:</div>
          <div className={styles.descValue}>{desc.materialDisplayName}</div>
        </div>
        ))
      }
    </div>
  )
}

const Description = ({ descList = [] }) => {
  return (
    <div className={styles.descWrapper}>
      <div>
        <DescriptionContent
          descList={descList}
        />
      </div>
    </div>
  )
}

const DescriptionModalElement = withDrawer(Description)

const DescriptionModal = props => {
  return <DescriptionModalElement headerTitle={props.$i18n.transl('core.product.description')} {...props} />
}

const activatesSectionButton = (key) => key === 'Enter' || key === ' '

const ProductDescription = ({ onClick, $i18n, $detector }) => {
  const isDesktop = $detector && $detector.isDesktop()
  const title = $i18n.transl('core.product.description')

  const handleKeyDown = (e) => {
    if (!onClick || !activatesSectionButton(e.key)) return
    if (e.key === ' ') {
      e.preventDefault()
    }
    onClick(e)
  }

  return (
    <h2
      className={cx(styles.section, isDesktop && styles.isDesktop)}
      role="button"
      tabIndex={0}
      aria-label={title}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      {title}
    </h2>
  )
}

export default ProductDescription

export {
  DescriptionModal,
  DescriptionContent
}